import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useContext } from 'react';
import { TabsContext } from '..';
import Theme from './theme';
export var TabPanelTheme = Theme;
/*::
import type { Node } from 'react';
import type { PanelThemeType } from './theme';

type TabPanelPropsType = {|
  id: string,
  children?: Node,
  theme?: PanelThemeType,
  rest?: any,
|};

export type PanelComponentProps = {
  id: string,
};
*/

var TabPanel = function TabPanel(_ref
/*: TabPanelPropsType */
) {
  var id = _ref.id,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "children", "theme"]);

  var _useContext = useContext(TabsContext),
      activeTab = _useContext.activeTab;

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    className: id === activeTab ? 'active' : '',
    "data-test": "tabs-panel-main"
  }, rest), children);
};

export default TabPanel;